import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'glxy-popover-title, [glxyPopoverTitle]',
  standalone: false,
})
export class PopoverTitleDirective {
  @HostBinding('class') class = 'glxy-popover-title';
}
